import React from 'react'
import { VscError } from 'react-icons/vsc'

const LadderError = ({ error }) => {
    const errorCode = String(error?.status_code || 'UNKNOWN')
    const errorKind = String(error?.error_kind || '').toLowerCase()
    const isTransientIssue = errorKind === 'transient_upstream' || errorKind === 'transient_network' || ['502', '503', '504'].includes(errorCode) || errorCode === 'NETWORK'
    const isServerIssue = errorKind === 'app_error' || errorCode === '500'
    const isRateLimited = errorCode === '429'

    const title = (() => {
        if (isTransientIssue) {
            return 'Temporary backend issue'
        }

        if (isServerIssue) {
            return 'We hit a server problem'
        }

        if (isRateLimited) {
            return 'Requests are temporarily limited'
        }

        if (errorCode === '408') {
            return 'Request timed out'
        }

        return 'Something went wrong'
    })()

    const details = (() => {
        if (isTransientIssue) {
            return 'The ladder service had a temporary network or gateway problem. A refresh usually fixes it.'
        }

        if (isServerIssue) {
            return 'Our API had trouble loading the ladder. Try again in a moment.'
        }

        if (isRateLimited) {
            return 'Too many ladder requests were sent in a short time. Please pause briefly and retry.'
        }

        if (errorCode === '408') {
            return 'That request took too long to finish. Please try again momentarily.'
        }

        return typeof error?.message === 'string' && error.message
            ? error.message
            : 'Please try again later.'
    })()

    const hintLine = (() => {
        if (isTransientIssue || isServerIssue) {
            return 'Refresh the page to try again.'
        }

        if (isRateLimited) {
            return 'Waiting a moment before retrying usually resolves it.'
        }

        return null
    })()

    return (
        <div className="mx-auto w-full max-w-2xl px-4 py-10 sm:py-14">
            <div className="rounded-xl border border-[#33333a] bg-black/78 p-5 shadow-[0_18px_60px_rgba(0,0,0,0.45)] sm:p-6">
                <div className="flex items-start gap-4">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-rose-900/55 bg-rose-950/35">
                        <VscError className="h-7 w-7 text-rose-300" aria-hidden="true" />
                    </div>
                    <div className="min-w-0 flex-1">
                        <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-zinc-400">
                            Ladder Error {errorCode}
                        </div>
                        <h1 className="mt-1 text-2xl font-semibold tracking-tight text-zinc-100 sm:text-[1.75rem]">
                            {title}
                        </h1>
                        <p className="mt-3 max-w-prose text-sm leading-6 text-zinc-300">
                            {details}
                        </p>
                        {hintLine ? (
                            <div className="mt-4 border-t border-[#33333a] pt-3 text-sm italic text-zinc-400">
                                {hintLine}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LadderError
